<template>
	<div>
		<el-tabs type="card" v-model="tagConfig">
			<el-tab-pane label="Config" name="tab-cadastro">
				<span slot="label"><i class="fa fa-list-alt"></i> Informações Cadastrais</span>

				<ed-form :data="formData" :config="config" :response="response" :itens="credenciadaItems">
					<div slot="form-footer"></div>
				</ed-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import FormItems  from './_form/parceiro-cadastrar'

  	export default {
  		name:"empresa",
  		components: {EdForm},
  		mixins:[Rest],
  		data () {
		   	return {
				config:{
					estado:true,
					cnae:true,
					click:{
						save:this.salvar,
					},
					loading:{
						save:false,
					},
				},
				response:{},
				credenciadaItems:[],
				formData:{
					id:0,
					nome:null,
					cnpj:null,
					ie:null,
					cnae:null,
					cep:null,
					id_estado:null,
					id_cidade:null,
					end:null,
					num:null,
					comp:null,
					bairro:null,
					tel_com:null,
					tel_cel:null,
					email:null,
					site:null,
					obs:null,
					resp:null,
				},
				tagConfig:'tab-cadastro'
			}
		},

		created(){
		},

		mounted: function() {
			this.credenciadaItems = FormItems;
		},
		methods: {

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};
				
				this.post('/laboratorio/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.$router.push({name:'ltcat.laboratorio.editar',params:{id:result.data.id}});
					}
				});
			}

		}
  	}
</script>

<style>


</style>



// WEBPACK FOOTER //
// cadastrar.vue?aef08aca